import { z } from "zod";

import { type BlogPost, BlogPostSchema, type BlogPostSummary, BlogPostSummarySchema } from "@/5-shared/types/Blog";

import { http } from "./http";
import { validate } from "./validate";

const BlogPostSummaryListSchema = z.array(BlogPostSummarySchema);

export async function fetchBlogPostsList(): Promise<BlogPostSummary[]> {
  const res = await http.get<BlogPostSummary[]>("/blog/posts");
  return validate(BlogPostSummaryListSchema, res.data, "fetchBlogPostsList");
}

export async function fetchBlogPost(id: string): Promise<BlogPost> {
  const res = await http.get<BlogPost>(`/blog/posts/${id}`);
  return validate(BlogPostSchema, res.data, "fetchBlogPost");
}

export async function fetchSuccessStoriesList(): Promise<BlogPostSummary[]> {
  const res = await http.get<BlogPostSummary[]>("/blog/success_stories");
  return validate(BlogPostSummaryListSchema, res.data, "fetchSuccessStoriesList");
}

export async function fetchSuccessStory(id: string): Promise<BlogPost> {
  const res = await http.get<BlogPost>(`/blog/success_stories/${id}`);
  return validate(BlogPostSchema, res.data, "fetchSuccessStory");
}
